import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentItem: {
        width: '100%',
        height: 70,
        borderRadius: 20,
        padding: 10,
        flexDirection: 'row',
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#24909c',
        marginTop: 10
    },
    img: {
        width: 32,
        height: 30,
        marginTop: 10,
        marginLeft: 10,
    },
    textsItem: {
        marginLeft: 20
    },
    infoTransactions: {
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    titleTransactions: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 5
    },
    infosTransactions: {
        fontSize: 10,
        color: '#2C2C2E',
        fontWeight: '400'
    },
    dateTransactions: {
        fontSize: 10,
        position: 'absolute',
        right: 65,
        marginTop: 28
    },
    iconGo: {
        position: 'absolute',
        right: 10,
        marginTop: 20
    }
});

export default styles;

